
// Mixin providing the forwarding of the v-model to a wrapped input
export default {
  name: 'SimpleInputWrapper',

  props: {
    label: String,
    name: String,
    value: null,
    defaultValue: null,
    readonly: Boolean
  },

  data () {
    return {
      innerValue: this.value // propagating v-model to the wrapped input (1/2)
    }
  },

  created () {
    if (this.innerValue === null && this.defaultValue) {
      this.innerValue = this.defaultValue
    }
  },

  watch: {
    innerValue (val) { // propagating v-model to the wrapped input (2/2)
      this.$emit('input', val)
    },
    value (newValue) {
      this.innerValue = newValue // react to changes in input prop
    }
  },

  methods: {
    inputBlur (valid) {
      if (valid) {
        this.$emit('input', this.innerValue?.trim?.() || this.innerValue)
        this.$emit('blur', this.innerValue?.trim?.() || this.innerValue)
      }
    },

    inputChange (valid) {
      if (valid) {
        this.$emit('input', this.innerValue?.trim?.() || this.innerValue)
        this.$emit('change', this.innerValue?.trim?.() || this.innerValue)
      }
    }
  }
}
